<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :disabled="disabled"
      :productLine="productLine"
      @openEditFormDialog="openEditFormDialog"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        @query="getData"
        @reset="resetPage"
        @openEditFormDialog="openEditFormDialog"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <el-dialog
      :visible.sync="goodsProofingDialogParams.visible"
      destroy-on-close
      width="500px"
      :title="goodsProofingDialogParams.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
    >
      <goodsProofingDialog
        ref="editForm"
        v-if="goodsProofingDialogParams.visible"
        :techGoodsSpecCode="goodsProofingDialogParams.code"
        :orderCode="orderCode"
        :disabled="goodsProofingDialogParams.disabled"
        @reload="reload"
        @save="save"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!goodsProofingDialogParams.disabled"
          @click="save()"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import EditLoading from '@/mixins/edit-loading'
import BaseTable from '@/mixins/base-table'
import GoodsProofingDialog from '../edit-form'

export default {
  components: {
    PageHeader,
    PageMain,
    GoodsProofingDialog,
  },
  mixins: [BaseTable, EditLoading],
  props: {
    orderCode: {
      type: String,
      default: '',
    },
    techCode: {
      type: String,
      default: '',
    },
    orderNo: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    productLine: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      usePage: true,
      goodsProofingDialogParams: {
        visible: false,
        title: '',
        disabled: false,
        code: '',
      },
    }
  },
  watch: {
    orderCode: {
      handler(val) {
        if (val) {
          this.getData({})
        }
      },
      immediate: true,
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .techGoodsSpecListApi({
          orderCode: this.orderCode,
          techCode: this.techCode,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    closeEditFormDialog() {
      this.goodsProofingDialogParams.visible = false
    },
    openEditFormDialog({ type, params = {} }) {
      const types = {
        add: this.$l('dialog_title_goods_add_info') || '添加产品信息',
        edit: this.$l('dialog_title_goods_edit_info') || '编辑产品信息',
        detail: this.$l('dialog_title_goods_detail_info') || '产品详情',
      }
      this.goodsProofingDialogParams = {
        visible: true,
        title: types[type],
        code: params.code,
        disabled: type === 'detail',
      }
    },

    async save() {
      this.$refs.editForm.getFormData().then((res) => {
        if (!res) return
        this.loadingOpen()
        //根据不同的操作调用不同接口
        let saveApi = {}
        if (!res.techGoodsSpecCode) {
          saveApi = this.$api.techGoodsSpecAddSaveApi({
            ...res,
            orderCode: this.orderCode,
            techCode: this.techCode,
          })
        } else {
          saveApi = this.$api.techGoodsSpecEditSaveApi({
            ...res,
            orderCode: this.orderCode,
            techCode: this.techCode,
          })
        }
        saveApi
          .then((res) => {
            this.loadingClose()
            this.closeEditFormDialog()
            const { status } = res
            if (status !== 200) {
              this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
              return
            }
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })

            this.reload()
          })
          .catch(() => {
            this.closeEditFormDialog()
            this.loadingClose()
          })
      })
    },
  },
}
</script>
